import { Box, Divider, Stack, useTheme } from "@mui/material";
import { useHotkeys } from "react-hotkeys-hook";
import { AppBuildInfo } from "@/components/AppBuildInfo";
import { useEngineApi } from "@/engine";
import { AddressSearchSection } from "./AddressSearchSection";
import { DrawingToolsValidationSection } from "./DrawingToolsValidationSection";
import { SendToKolegaSection } from "./SendToKolegaSection";
import { SettingsSection } from "./SettingsSection";
import { ShapesModificationSection } from "./ShapesModificationSection";
import { ToolsSection } from "./ToolsSection";

declare global {
	interface Window {
		chrome?: {
			webview?: {
				postMessage: (message: unknown) => void;
			};
		};
	}
}

const SidePanel = () => {
	const theme = useTheme();
	const api = useEngineApi();

	useHotkeys("esc", () => api.workspace3D.tools.cancelCurrentSketch(), { enableOnFormTags: true });
	useHotkeys("delete, backspace", () => api.kolega3D.tools.deleteSelectedShape(), { enableOnFormTags: false });

	return (
		<Box
			sx={{
				boxSizing: "border-box",
				position: "absolute",
				top: 0,
				right: 0,
				padding: "16px",
				width: "320px",
				maxHeight: "100%",
				backgroundColor: "#F5F5F5",
				boxShadow: theme.shadows[1],
				overflow: "auto",
				zIndex: theme.zIndex.appBar,
			}}
		>
			<Stack direction="column" spacing={2}>
				<AddressSearchSection />

				<Divider />

				<DrawingToolsValidationSection />

				<ToolsSection />

				<ShapesModificationSection />

				<Divider />

				<SettingsSection />

				<Divider />

				<SendToKolegaSection />

				<Divider />

				<AppBuildInfo />
			</Stack>
		</Box>
	);
};

export { SidePanel };
